@if(savingForm){
<create-account-placeholder-component [setHeight]="true" [formName]="data.title"></create-account-placeholder-component>
}
<div
  style="justify-content: flex-start; border-width: 0px !important"
  class="app__itemCard app__solid--border rounded-xl bg-white border-[#e2e4e5] py-[18px] w-[412px] h-auto max-h-[580px]"
  [ngClass]="savingForm ? 'h-0 invisible absolute w-0' : visibility ? 'relative overflow-hidden h-auto' : 'relative overflow-hidden h-auto'"
>
  <div class="app__centered-item justify-between mb-[-5px]">
    <p class="text-lg font-bold leading-[22px] text-[#1E1E20]">
      <span>Select Vault</span>
    </p>
    <div class="app__close--icon mt-[-37px] mr-[-16px]">
      <button class="hover:cursor-pointer" matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons text-[#898F9E] text-[24px] leading-7 font-bold">clear</span>
      </button>
    </div>
  </div>
  <hr class="mx-[-26px]" />
  <div class="search__template d-flex">
    <div class="app__discovery--header--search--field bg-[#FFFFFF] h-[36px]">
      <div class="w-full h-full px-5" style="display: flex; align-items: center; justify-content: space-between">
        <div>
          <span> <img src="assets/images/blue-search-icon.svg" /> </span>
          <input
            #templateSearchInput
            type="text"
            matInput
            [(ngModel)]="searchTextType"
            autofocus
            placeholder="Search Vaults"
            class="outline-none ml-1"
          />
        </div>
      </div>
    </div>
  </div>
  <div>
    <div style="margin-top: 12px" class="template overflow-auto bg-white max-h-[425px] h-[425px] p-3 rounded">
      <div class="task__forms" #formDropdown>
        <div class="task__forms-list">
          <p style="color: rgb(198, 193, 193); font-size: 15px" *ngIf="(vault_list | filterVaultListName : searchTextType)?.length == 0">
            No results found
          </p>
          <ul *ngFor="let vault of vault_list | filterVaultListName : searchTextType" class="mb-3">
            <li class="d-flex justify-content-between cursor-pointer" (click)="selectFormForTypeTask(vault)">
              <div class="d-flex list-container justify-between w-full">
                <div class="flex" style="width: calc(100% - 72px)">
                  <img [src]="'assets/images/' + vault?.type + '-small.svg'" class="h-10 w-10 rounded p-2 bg-[#EBF0FA]" />
                  <div class="pl-3 flex items-start justify-start flex-col">
                    <p class="form-name mb-0 text-xs font-semibold text-[#18191C]" [matTooltip]="vault?.name">
                      {{ vault?.name | truncateStrPipe : 36 }}
                    </p>
                    <span class="paragraph__medium text-[10px] font-medium text-[#707070]"> {{ vault?.type | capitalizeFirstWord }}</span>
                  </div>
                </div>
                <button
                  style="min-width: 60px"
                  class="bg-white text-[#25508E] text-xs rounded border w-[60px] h-[28px] border-[#25508E] hover:bg-[#EBF0FA]"
                >
                  Select
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
